/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="block-cart-item" :title="product.name" :sub-title="productSku">
    <div class="cart-item">
      <div class="cart-item__media">
        <img-product
        :imgPath="productImage"
        :alt="product.name"
        size="lg"
        />
      </div>
      <div class="cart-item__info">
        <div class="cart-item__info__name d-flex align-items-center">
          <span class="title">{{ product.name }}</span>
        </div>
        <div class="cart-item__info__selections">
          <product-selected-options :variants="selectedOptions"></product-selected-options>
        </div>
        <div class="cart-item__info__actions">
          <div class="wrapp-price">
            <span class="product-qty">{{qty}} x </span>
            <div class="price-calculation ml-2">
              <span class="product-price_final mr-2">{{ price | price($store) }}</span>
              <span class="product-price_original" v-show="originalPrice">{{ originalPrice | price($store) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MiniCartProduct from 'theme/components/Cart/MiniCartProduct'

export default {
  name: 'ResumeProduct',
  mixins: [MiniCartProduct]
}
</script>
